//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useEffect, useState, useContext } from "react";
import * as moment from "moment";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import access from "config/access";
// custom pages
import EmailLogsApi from "apis/emailLogs/emailLogs";
import { styles } from "./style";
import Loader from "components/Loader/Loader";
import Table from "components/Table/Table";
import Context from "context/context";

// material-ui
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import { validateEmail } from "helpers/validateEmail";
import { useTranslation } from 'react-i18next';
import { dateFormat } from "helpers/dataFormat"
import { enUS, fr } from "date-fns/locale";
import { CSVLink } from 'react-csv';
import { exportHeaders } from "./export";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const sendEmailTransition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

function EmailLogs() {
  const { state, dispatch } = useContext(Context);
  const { getAll, filterApi, resendMail, search, sendEmail, getEmails,exportfile } =
    EmailLogsApi();
  const classes = styles();
  const history = useHistory();

  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [filter, setFilter] = useState(false);
  const [filterApplied, setFilterApplied] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [status, setStatus] = useState("");
  const [type, setType] = useState("");
  const [memberID, setMemberID] = useState("");
  const [recipientEmail, setRecipientEmail] = useState("");
  const [consentFlag, setConsentFlag] = useState(null);
  const [open, setOpen] = useState(false);
  const [id, setId] = useState("");
  const [emailPopOpen, setEmailPopOpen] = useState(false);
  const [loyaltySearch, setLoyaltySearch] = useState("");
  const [loyaltyLoading, setLoyaltyLoading] = useState(false);
  const [emailAddress, setEmailAddress] = useState("");
  const [loyaltyData, setLoyaltyData] = useState([]);
  const [loyaltyType, setLoyaltyType] = useState(null);
  const [emailErrorText, setEmailErrorText] = useState("");
  const [dropDownErrorText, setDropDownErrorText] = useState("");
  const [loyaltyErrorText, setLoyaltyErrorText] = useState("");
  const [filterErrorText, setFilterErrorText] = useState({
    startDate: "",
    endDate: "",
    type: "",
    status: "",
    email: "",
    memberID: "",
    consentFlag: "",
  });
  const [emailList, setEmailList] = useState([]);
  const [exportData, setExportData] = useState([]);
  const { t, i18n } = useTranslation()
  useEffect(() => {
    if (filterApplied) {
      handleFilter();
    } else {
      getAllData();
    }
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Email Logs"],
    });
  }, [offset]);

  useEffect(() => {
    if (loyaltySearch.length > 0) {
      setLoyaltyLoading(true);
      handleSearch();
      handleGetEmails();
    }
  }, [loyaltySearch]);

  async function getAllData() {
    try {
      let values;
      values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await getAll(values);
      dispatch({ type: "SET_LOADING", payload: false });
      setData(res.data);
      setCount(res.count);
    } catch (e) {
      console.log({ e });
    }
  }

  // const handleExport = async () => {
  //   try {
  //     let values;
  //     values = {
  //       offset: (offset - 1) * 30,
  //       limit: 30,
  //     };
  //     dispatch({ type: "SET_LOADING", payload: true });
  //     let res = await exportfile(values);
  //     dispatch({ type: "SET_LOADING", payload: false });
  //     setExportData(res.data);
  //     setCount(res.count);
  //   } catch (e) {
  //     console.log({ e });
  //   }
  // }

  const handleExport = async () => {
    let values = {};
    if (fromDate && toDate) {
      values = {
        ...values,
        fromDate,
        toDate,
      };
    }
    if (status) {
      values = {
        ...values,
        status,
      };
    }
    if (type) {
      values = {
        ...values,
        type,
      };
    }
    if (recipientEmail) {
      values = {
        ...values,
        to: recipientEmail,
      };
    }
    if (memberID) {
      values = {
        ...values,
        loyalty_id: memberID,
      };
    }
    if (typeof consentFlag === "boolean") {
      values = {
        ...values,
        consentFlag,
      };
    }



    dispatch({ type: "SET_LOADING", payload: true });
    let res = await exportfile(values);
    console.log(res,"ragav")
    if (res && res.data) {
      // setIsLoading(false);
      setExportData(res.data.map((d) => {
        return {
          ...d,
            ['Loyalty_Account.consent_flag']:d['Loyalty_Account.consent_flag']? 'true' : 'false',
            ['Loyalty_Account.is_active']:d['Loyalty_Account.is_active']?'Active':'Inactive'

          }}))
      dispatch({ type: "SET_LOADING", payload: false });

      if (res.data.length === 0) {
        toast.success(t("No Data Found"), { toastId: "no-report-date" });
        return false;
      }

      return true;
    }
  }

  async function handleFilter() {
    try {
      setFilterApplied(true);
      let values;
      values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
      if (fromDate && toDate) {
        values = {
          ...values,
          fromDate,
          toDate,
        };
      }
      if (status) {
        values = {
          ...values,
          status,
        };
      }
      if (type) {
        values = {
          ...values,
          type,
        };
      }
      if (recipientEmail) {
        values = {
          ...values,
          to: recipientEmail,
        };
      }
      if (memberID) {
        values = {
          ...values,
          loyalty_id: memberID,
        };
      }
      if (typeof consentFlag === "boolean") {
        values = {
          ...values,
          consentFlag,
        };
      }
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await filterApi(values);
      dispatch({ type: "SET_LOADING", payload: false });
      setData([...res.data]);
      setCount(res.count);
      setFilterErrorText({
        startDate: "",
        endDate: "",
        type: "",
        status: "",
        email: "",
        memberID: "",
        consentFlag: "",
      });
    } catch (e) {
      console.log({ e });
    }
  }

  async function handleResendMail() {
    try {
      let values = {
        id: id,
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await resendMail(values);
      dispatch({ type: "SET_LOADING", payload: false });
      if (res.type === "success") {
        history.push("/dashboard/upload-success", {
          type: i18n.language == 'fr' ? res.french_message : res.message,
        });
      }
    } catch (e) {
      console.log({ e });
    }
  }

  async function handleSearch() {
    try {
      let res = await search(loyaltySearch);
      setLoyaltyLoading(false);
      if (res) {
        setLoyaltyData(res.data);
      }
    } catch (e) {
      console.log({ e });
    }
  }

  async function handleGetEmails() {
    try {
      let res = await getEmails(loyaltySearch);
      if (res && res.data && res.data.length > 0) {
        setEmailList(res.data);
      }
    } catch (e) {
      console.log({ e });
    }
  }

  async function handleSend() {
    try {
      let values = {
        loyaltyId: loyaltySearch,
        type,
        email: emailAddress,
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await sendEmail(values);
      dispatch({ type: "SET_LOADING", payload: false });
      setLoyaltySearch("");
      setType("");
      setEmailAddress("");
      setEmailErrorText("");
      setLoyaltyErrorText("");
      setDropDownErrorText("");
      if (res.type === "success") {
        history.push("/dashboard/upload-success", {
          type: i18n.language == 'fr' ? res.french_message : res.message,
        });
      } else {
        return toast.error(i18n.language == 'fr' ? res.french_message : res.message);
      }
    } catch (e) {
      console.log({ e });
    }
  }

  const headings = [
    "Email Type",
    "Status",
    "Date",
    "Start",
    "End",
    "Recipient Email ID",
    "Member ID",
    "Account Status",
    "Consent Flag",
    "Process Type",
    "",
  ];

  // change pagination func
  const handlePagination = (value) => {
    setOffset(value);
  };

  const locale = i18n.language == 'fr' ? fr : enUS;

  return (
    <div>
      <div className={classes.btnDiv}>
        <button
          className={classes.sendEmailBtn}
          onClick={() => setEmailPopOpen(true)}
        >
          {t('Send Email')}
        </button>
        <button
          className={classes.filterBtn}
          onClick={() => setFilter(!filter)}
        >
          {t('Filter')}
        </button>
        <CSVLink
          id="csv"
          data={exportData
          }
          headers={exportHeaders}
          filename={
            `Email-Logs` +
            " " +
            moment(new Date()).format("MM-DD-YYYY,h:mm A") +
            ".csv"
          }
          className={classes.CSVlink}
        />
        <button
          // disabled={isLoading}
          className={classes.exportBtn1}
          onClick={async () => {
            let res = await handleExport();
            if (res) {
              document.getElementById("csv").click();
            }
          }}
        >
          {t('Export')}
        </button>
      </div>

      {filter && (
        <div>
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <Card className={classes.filterCard}>
                <Grid
                  container
                  spacing={2}
                  className={classes.filterCardGridContainer}
                  style={{ padding: 10 }}
                >
                  <Grid item md={2} xs={12} className={classes.filterCardGrid}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                      <KeyboardDatePicker
                        disableToolbar
                        variant="inline"
                        format={i18n.language == "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
                        margin="normal"
                        label={t("Start Date")}
                        id="date-picker-inline"
                        className={classes.dateInput}
                        value={fromDate}
                        maxDate={new Date()}
                        onChange={(date) => {
                          setFromDate(date);
                          setEmailErrorText("");
                        }}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                        autoOk
                        helperText={filterErrorText?.startDate}
                        error={
                          filterErrorText?.startDate.length > 0 ? true : false
                        }
                      />
                    </MuiPickersUtilsProvider>
                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                      <KeyboardDatePicker
                        disableToolbar
                        variant="inline"
                        format={i18n.language == "en" ? "MM/dd/yyyy" : "dd/MM/yyyy"}
                        margin="normal"
                        label={t("End Date")}
                        id="date-picker-inline2"
                        className={classes.dateInput}
                        value={toDate}
                        maxDate={new Date()}
                        onChange={(date) => {
                          setToDate(date);
                        }}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                        autoOk
                        helperText={filterErrorText?.endDate}
                        error={
                          filterErrorText?.endDate.length > 0 ? true : false
                        }
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid item md={2} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t('Status')}</div>
                    <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type="text"
                      autoComplete="off"
                      value={status}
                      onChange={(e) => {
                        setStatus(e.target.value);
                      }}
                      helperText={filterErrorText?.status}
                      error={filterErrorText?.status.length > 0 ? true : false}
                    >
                      <MenuItem className={classes.menuItem} value={"SUCCESS"}>
                        {t('SUCCESS')}
                      </MenuItem>
                      <MenuItem className={classes.menuItem} value={"FAILED"}>
                        {t('FAILED')}
                      </MenuItem>
                      <MenuItem className={classes.menuItem} value={"HOLD"}>
                        {t('HOLD')}
                      </MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item md={2} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t('Type')}</div>
                    <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "12px !important", width: "100%" }}
                      type="text"
                      autoComplete="off"
                      value={type}
                      onChange={(e) => {
                        setType(e.target.value);
                      }}
                      helperText={filterErrorText?.type}
                      error={filterErrorText?.type.length > 0 ? true : false}
                    >
                      <MenuItem
                        className={classes.menuItem}
                        value={"enrollmentStatus"}
                      >
                        {t('AUTO ENROLLMENT STATUS')}
                      </MenuItem>
                      {state?.userInfo?.loyalty_organization_name === 'Henry Schein Dental' ? (
                        <MenuItem className={classes.menuItem} value={"dayOfEnrollment"}>
                          {t('AUTO ENROLLMENT ADMIN CONSENT')}
                        </MenuItem>
                      ) : state?.userInfo?.loyalty_organization_name === 'Henry Schein Canada' ? (
                        <MenuItem className={classes.menuItem} value={"enrollmentAdminConsent"}>
                          {t('AUTO ENROLLMENT ADMIN CONSENT')}
                        </MenuItem>
                        
                      ) : null}
                      <MenuItem
                        className={classes.menuItem}
                        value={"AUTO_TRANSFER_STATUS"}
                      >
                        {t('AUTO TRANSFER STATUS')}
                      </MenuItem>
                      <MenuItem
                        className={classes.menuItem}
                        value={"AUTO_TRANSFER_ADMIN_CONSENT"}
                      >
                        {t('AUTO TRANSFER ADMIN CONSENT')}
                      </MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item md={2} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>
                      {t('Recipient Email ID')}
                    </div>
                    <TextField
                      variant="outlined"
                      style={{ fontSize: "12px !important", width: "100%" }}
                      type="email"
                      autoComplete="off"
                      value={recipientEmail}
                      onChange={(e) => {
                        setRecipientEmail(e.target.value);
                      }}
                      helperText={filterErrorText.email}
                      error={filterErrorText?.email.length > 0 ? true : false}
                    />
                  </Grid>
                  <Grid item md={2} xs={12} className={classes.filterCardGrid}>
                    <div className={classes.filterCardHeadText}>{t("Member ID")}</div>
                    <TextField
                      variant="outlined"
                      style={{ fontSize: "12px !important", width: "100%" }}
                      type="text"
                      autoComplete="off"
                      value={memberID}
                      onChange={(e) => {
                        setMemberID(e.target.value);
                      }}
                      helperText={filterErrorText.memberID}
                      error={
                        filterErrorText?.memberID.length > 0 ? true : false
                      }
                    />

                    <div className={classes.filterCardHeadText}>
                      {t('Consent Flag')}
                    </div>
                    <TextField
                      variant="outlined"
                      style={{ fontSize: "12px !important", width: "100%" }}
                      select
                      autoComplete="off"
                      value={consentFlag}
                      onChange={(e) => {
                        setConsentFlag(e.target.value);
                      }}
                      helperText={filterErrorText?.consentFlag}
                      error={
                        filterErrorText?.consentFlag ? true : false
                      }
                    >
                      <MenuItem className={classes.menuItem} value={true}>
                        {t('True')}
                      </MenuItem>
                      <MenuItem className={classes.menuItem} value={false}>
                        {t('False')}
                      </MenuItem>
                    </TextField>
                  </Grid>
                  <Grid
                    item
                    md={2}
                    xs={12}
                    className={classes.filterCardBtnGrid}
                  >
                    {filterApplied && (
                      <button
                        className={classes.filterCardResetBtn}
                        style={{
                          fontSize: "0.875rem",
                          height: 35,
                        }}
                        onClick={() => {
                          setFromDate(null);
                          setToDate(null);
                          setStatus("");
                          setType("");
                          setRecipientEmail("");
                          setMemberID("");
                          setConsentFlag(null);
                          setFilterApplied(false);
                          if (offset === 1) {
                            getAllData();
                          } else {
                            setOffset(1);
                          }
                          setFilterErrorText({
                            startDate: "",
                            endDate: "",
                            type: "",
                            status: "",
                            email: "",
                            memberID: "",
                            consentFlag: null,
                          });
                        }}
                      >
                        {t('Reset')}
                      </button>
                    )}

                    <button
                      className={classes.filterCardApplyBtn}
                      style={{
                        fontSize: "0.875rem",
                        height: 35,
                      }}
                      onClick={() => {
                        if (moment(fromDate).isAfter(toDate)) {
                          setFilterErrorText({
                            ...filterErrorText,
                            startDate:
                              "Start date should be less than End date",
                            endDate:
                              "End date should be greater than Start date",
                          });
                          return;
                        }
                        if (
                          !fromDate &&
                          !toDate &&
                          !status &&
                          !type &&
                          !memberID &&
                          !recipientEmail &&
                          consentFlag === null
                        ) {
                          setFilterErrorText({
                            ...filterErrorText,
                            startDate: "Please select atleast one field",
                            endDate: "Please select atleast one field",
                            type: "Please select atleast one field",
                            status: "Please select atleast one field",
                            email: "Please select atleast one field",
                            memberID: "Please select atleast one field",
                            consentFlag: "Please select atleast one field",
                          });
                          return;
                        }

                        if (recipientEmail && recipientEmail.length > 0) {
                          let con = validateEmail(recipientEmail);
                          if (!con) {
                            setFilterErrorText({
                              ...filterErrorText,
                              email: "Please enter valid Email ID",
                            });
                            return;
                          }
                        }
                        if (!fromDate && toDate) {
                          setFilterErrorText({
                            ...filterErrorText,
                            startDate: "Please select start date",
                          });
                          return;
                        }
                        if (fromDate && !toDate) {
                          setFilterErrorText({
                            ...filterErrorText,
                            endDate: "Please select end date",
                          });
                          return;
                        }
                        setFilterApplied(true);

                        if (offset === 1) {
                          handleFilter();
                        } else {
                          setOffset(1);
                        }
                      }}
                    >
                      {t('Apply')}
                    </button>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </div>
      )}

      <Loader Loading={state.loading} top={"15%"}>
        <div className={classes.responsiveTable}>
          <Grid item xs={12} sm={12} lg={12}>
            <Table
              headings={headings.map((i) => (
                <div key={t(i)}
                  className={
                    i === "Date" ? classes.dateColumn : classes.tableHeadings
                  }
                >
                  {t(i)}
                </div>
              ))}
              data={data.map((p, i) => [
                <div style={{ fontSize: 12 }}>{[t(p?.email_type)]}</div>,
                p?.status === "SUCCESS" ? (
                  <span style={{ color: "green" }}>{[t(p?.status)]}</span>
                ) : (
                  <span style={{ color: "red" }}>{[t(p?.status)]}</span>
                ),
                [dateFormat(p?.run_date, i18n.language)],
                p?.start_time === null
                  ? ["--"]
                  : [moment(p?.start_time).format("hh:mm:ss A")],
                p?.end_time === null
                  ? ["--"]
                  : [moment(p?.end_time).format("hh:mm:ss A")],
                [p?.to],
                [p?.loyalty_id],
                [
                  p?.["Loyalty_Account.is_active"] === true
                    ? (<span style={{ color: "green" }}>{t("Active")}</span>
                    ) : (
                      <span style={{ color: "red" }}>{t("InActive")}</span>
                    )
                ],
                [
                  p?.["Loyalty_Account.consent_flag"] === true
                    ? "True"
                    : "False",
                ],
                [
                  (p?.process_type === 0 && "Auto") ||
                  (p?.process_type === 1 && "Manual") ||
                  "-",
                ],
                [
                  <button
                    className={classes.resendBtn}
                    onClick={() => {
                      if (state?.userInfo?.editAction) {
                        setId(p?.id);
                        setOpen(true);
                        return;
                      }
                      else {
                        toast.error(state.userInfo?.editAccess)
                        return;
                      }
                    }}
                  // disabled={!access['editAccess'][state.userInfo?.role]['email-logs']}
                  >
                    {t('Resend')}
                  </button>,
                ],
              ])}
              offset={offset}
              count={
                (count / 10) % 1 == 0
                  ? Math.floor(count / 10)
                  : Math.floor(count / 10 + 1)
              }
              handlePagination={handlePagination}
            />
          </Grid>
        </div>
      </Loader>

      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setOpen(false)}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div style={{ fontSize: 16, color: "#000", textAlign: "center" }}>
              {t('Are you sure to resend an email?')} <br />
              <button className={classes.noBtn} onClick={() => setOpen(false)}>
                {t('No')}
              </button>
              <button
                className={classes.yesBtn}
                onClick={() => {
                  setOpen(false);
                  handleResendMail();
                }}
              >
                {t('Yes')}
              </button>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <Loader loading={state.Loading}>
        <Dialog
          open={emailPopOpen}
          TransitionComponent={sendEmailTransition}
          keepMounted
          onClose={() => setEmailPopOpen(false)}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <span
                style={{ float: "right", color: "red", cursor: "pointer" }}
                onClick={() => {
                  setLoyaltySearch("");
                  setType("");
                  setEmailAddress("");
                  setLoyaltyType(null);
                  setEmailPopOpen(false);
                  setEmailErrorText("");
                  setLoyaltyErrorText("");
                  setDropDownErrorText("");
                  setLoyaltyData([]);
                  setEmailList([]);
                }}
              >
                X
              </span>
              <h1 style={{ textAlign: "center" }}>{t('Send Email')}</h1>
              <div style={{ fontSize: 16, color: "#000", padding: "20px" }}>
                <Autocomplete
                  autoSelect={true}
                  options={loyaltyData}
                  inputValue={loyaltySearch}
                  getOptionLabel={(o) => o.loyalty_id}
                  filterOptions={(options, state) => options}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label={t("Search by Loyalty ID")}
                      value={loyaltySearch}
                      className={classes.emailPopTextField}
              onWheel={(e) => e.target.blur()}
                      onChange={(e) => {
                        setLoyaltySearch(e.target.value);
                      }}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {loyaltyLoading ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                      helperText={loyaltyErrorText}
                      error={loyaltyErrorText.length > 0 ? true : false}
                    />
                  )}
                  onChange={(value, a, reason) => {
                    if (reason === "clear") {
                      setLoyaltySearch("");
                      return;
                    }
                    if (a) {
                      setLoyaltySearch(a.loyalty_id);
                      setLoyaltyType(a.member_account_created_by);
                    }
                  }}
                />
                <TextField
                  label={t("Type")}
                  id="email-type"
                  select
                  variant="outlined"
                  className={classes.emailPopTextField}
                  value={type}
                  onChange={(e) => {
                    setType(e.target.value);
                  }}
                  helperText={dropDownErrorText}
                  error={dropDownErrorText.length > 0 ? true : false}
                >
                  <MenuItem
                    className={classes.menuItem}
                    value={"AUTO_ENROLLMENT_STATUS"}
                  >
                    {t('AUTO ENROLLMENT STATUS')}
                  </MenuItem>

                  <MenuItem
                    className={classes.menuItem}
                    value={"AUTO_ENROLLMENT_ADMIN_CONSENT"}
                  >
                    {t('AUTO ENROLLMENT ADMIN CONSENT')}
                  </MenuItem>

                  {/* {(loyaltyType == 2 || loyaltyType == 4) && (
                    <MenuItem
                      className={classes.menuItem}
                      value={"AUTO_TRANSFER_STATUS"}
                    >
                      {t('AUTO TRANSFER STATUS')}
                    </MenuItem>
                  )}
                  {(loyaltyType == 2 || loyaltyType == 4) && (
                    <MenuItem
                      className={classes.menuItem}
                      value={"AUTO_TRANSFER_ADMIN_CONSENT"}
                    >
                      {t('AUTO TRANSFER ADMIN CONSENT')}
                    </MenuItem>
                  )} */}
                </TextField>
                <br />
                <TextField
                  id="to-email"
                  select
                  variant="outlined"
                  label={t("Recipient Email ID")}
                  className={classes.emailPopTextField}
                  value={emailAddress}
                  onChange={(e) => {
                    setEmailAddress(e.target.value);
                  }}
                  helperText={emailErrorText}
                  error={emailErrorText.length > 0 ? true : false}
                >
                  {emailList?.map((list, index) => {
                    return (
                      <MenuItem
                        key={index}
                        className={classes.menuItem}
                        value={list["User.email"] || list["User.username"]}
                      >
                        {list["User.email"] || list["User.username"]}
                      </MenuItem>
                    );
                  })}
                </TextField>
                <div style={{ textAlign: "center" }}>
                  <button
                    className={classes.cancelBtn}
                    onClick={() => {
                      setLoyaltySearch("");
                      setType("");
                      setEmailAddress("");
                      setEmailPopOpen(false);
                      setLoyaltyType(null);
                      setEmailErrorText("");
                      setLoyaltyErrorText("");
                      setDropDownErrorText("");
                      setLoyaltyData([]);
                      setEmailList([]);
                    }}
                  >
                    {t('Cancel')}
                  </button>

                  <button
                    className={classes.sendBtn}
                    onClick={() => {
                      if (state?.userInfo?.editAction) {
                        if (type === "")
                          setDropDownErrorText("This is a required field");
                        if (loyaltySearch === "")
                          setLoyaltyErrorText("This is a required field");
                        if (emailAddress === "")
                          setEmailErrorText("This is a required field");
                        if (
                          type !== "" &&
                          loyaltySearch !== "" &&
                          emailAddress !== ""
                        ) {
                          setEmailPopOpen(false);
                          handleSend();
                        }
                        return;
                      }
                      else {
                        toast.error(state.userInfo?.editAccess)
                        return;
                      }
                    }}
                  // disabled={!access['editAccess'][state.userInfo?.role]['email-logs']}
                  >
                    {t('Send')}
                  </button>
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </Loader>
    </div>
  );
}

export default EmailLogs;
